/**
 * @generated SignedSource<<e86b29eaaaf55b4e805d8c33972b6689>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfilePopper_user$data = {
  readonly emailAddress: string;
  readonly fullName: string;
  readonly id: string;
  readonly " $fragmentType": "ProfilePopper_user";
};
export type ProfilePopper_user$key = {
  readonly " $data"?: ProfilePopper_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfilePopper_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfilePopper_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "fecea792f4c5b8bd4e3295a51c4dbba4";

export default node;
